export default {
  data: () => ({
    drawer: false,
    group: null,
    closeOnClick: false
  })
};
